<template>
  <div class="tech-map-result">
    <div class="container-wrapper">
      <div class="container">
        <h2 class="tech-map-result__title">{{ componentData.title }}</h2>
        <BaseTabs
          :tabs="componentData.tabs"
          class="tech-map-result__tabs"
          @tabChange="activeTab = $event"
        />
        <transition name="slide-to-right" mode="out-in">
          <TablePrice
            v-if="table && table.type === 'price'"
            :key="`table-price-${activeTab.value}`"
            class="tech-map-result__table"
            :rows="table.rows"
            :optionalMaterials="componentData.tables.optionalMaterials"
            :materials="componentData.tables.materials_list"
            :warning="table.warning"
            :addWorkPackage="table.addWorkPackage"
            :excludePackageMessage="table.excludePackageMessage"
            @oilChange="setOil"
          />
          <BaseTable
            v-if="table && table.type === 'base'"
            :key="`table-secondary-${activeTab.value}`"
            :expandText="table.viewAllButtonText"
            :rows="table.rows"
            class="tech-map-result__table tech-map-result__table_oil"
            @oilChange="setOil"
          />
        </transition>

        <NotificationBanner
          v-if="$store.state.vinSearchData.modelOpenCampaignsMessage"
          :msg="$store.state.vinSearchData.modelOpenCampaignsMessage"
          class="tech-map-result__notification"
        />

        <div class="tech-map-result__request-service-button-container">
          <BaseButton @click="requestService">
            {{ componentData.serviceRequestButtonText }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TablePrice from '@/components/TablePrice'
  import NotificationBanner from '@/components/NotificationBanner'
  import { mapGetters } from 'vuex'
  import { get } from 'lodash'
  import { DEFAULT_LANG } from '@/helpers/constant'

  export default {
    name: 'TechMapFiltrationResult',
    components: {
      TablePrice,
      NotificationBanner
    },
    props: {
      arrayOil: {
        type: Array
      },
      componentData: {
        type: Object,
        required: true
      },
      oilsPayload: {
        type: [String, Number],
        default: ''
      },
      currentFilter: Object,
      oilChange: Function
    },
    data () {
      return {
        activeTab: null
      }
    },
    computed: {
      ...mapGetters(['getPeriod', 'getCity', 'getDealer']),
      table () {
        return this.activeTab && this.componentData.tables[this.activeTab.value]
      }
    },
    mounted () {
      this.componentData.tables.materials_list.rows.forEach((element, index) => {
        try {
          if (element['col-1'].list[0].id) {
            this.$emit('oilChange', element['col-1'].list[0].id, index)
          }
        } catch (er) {}
      })
    },
    methods: {
      setOil (value, column) {
        this.$emit('oilChange', value, column)
        this.$store.commit('SET_OIL_ID', value, column)
      },
      requestService () {

        const lang = this.$store.state.currentLang
        const queryLang = lang !== DEFAULT_LANG ? { lang } : {}

        this.$router.push({
          name: 'service-request',
          query: {
            period: this.getPeriod || this.currentFilter.period,
            city: this.getCity || this.currentFilter.city,
            dealer: this.getDealer || this.currentFilter.dealer,
            oil: this.arrayOil.filter(item => item).join(','),
            workpackages: this.$route.query.workpackages,
            ...queryLang
          },
          params: {
            oil: this.arrayOil.filter(item => item).join(','),
          }
        })
      }
    }
  }
</script>

<style lang="scss">
.tech-map-result {
  min-height: 900px;
  padding-bottom: 70px;
  overflow-x: hidden;
  background: $c-gray-light;

  @include mobile {
    min-height: 700px;
    padding-bottom: 1px;
  }

  &__title {
    margin: 25px 0 45px;
    text-align: left;

    @include mobile {
      margin: 0 0 45px;
    }
  }

  &__tabs {
    margin-bottom: 25px;

    @include mobile {
      margin-bottom: 12px;
    }
  }

  &__table {
    position: relative;

    &_oil {
      .select__field {
        width: max-content;
        font-size: 15px;
      }
    }
  }

  &__notification {
    margin-top: 40px;
    margin-bottom: 40px;

    @include mobile {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }

  &__request-service-button-container {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 40px;

    @include mobile {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
}
</style>
